import _isGlob from 'is-glob'
import _glob from 'picomatch'

export type GlobOptions = _glob.PicomatchOptions

const cache = new Map<string, RegExp>()

export function glob(
  glob: string,
  path: string,
  options?: GlobOptions
): boolean {
  const regex = cache.get(glob)
  if (regex !== undefined) return regex.test(path)
  if (isGlob(glob)) {
    const regex = _glob.makeRe(glob, options)
    cache.set(glob, regex)
    return regex.test(path)
  } else return false
}

export function isGlob(val?: any): val is string {
  return typeof val === 'string' ? _isGlob(val) : false
}
